import React from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Tooltip} from "@irati/ui/src/Tooltip"

import {Text} from "./styled"

interface Props extends InjectIntl {
  cx: number
  cy: number
  index: number
  text: string
  finalIndex?: number
}

const BenchmarkText = (props: Props) => {
  const {cx, cy, index, text, finalIndex = 5, formatMessage} = props

  if (index === finalIndex) {
    return (
      <Tooltip tooltipChildren={formatMessage({id: "admin.components.benchmark.xaxisTooltip"})} placement="left">
        <>
          {text.split(" ").map((line, i) => (
            <Text key={`${line}-${i}`} x={cx + 22} y={cy + 10 + i * 10} viewBox="0 0 1024 1024">
              {line}
            </Text>
          ))}
        </>
      </Tooltip>
    )
  }
  return null
}

export default injectIntl(BenchmarkText)
